import React, { useState, useEffect } from 'react'
import KRGlue from '@lyracom/embedded-form-glue'
import allActions from '../../redux/actions/user'

import { useSnackbar } from 'notistack'
import { useDispatch } from 'react-redux'
import { useRef } from 'react'
import { memo } from 'react'


export default memo(Paiement)

function Paiement(props) {

  const { amount, callback, reload } = props

  const dispatch = useDispatch()
  const [promiseError, setpromiseError] = useState('')
  const [formToken, setformToken] = useState('')

  let endpoint = process.env.REACT_APP_PAYZEN_DOMAIN_URL
  
  let publicKey = process.env.REACT_APP_PUBLIC_KEY
  if (process.env.REACT_APP_MODE === 'TEST') publicKey = process.env.REACT_APP_PUBLIC_KEY_TEST
  if (process.env.REACT_APP_MODE === 'PROD') publicKey = process.env.REACT_APP_PUBLIC_KEY_PROD

  const { enqueueSnackbar } = useSnackbar()

  const KR = useRef(null)


  useEffect(() => {
    async function fetchData() {
      var payload = {
        'amount': amount ?? 11090,
        'currency': 'EUR',
        'ipnTargetUrl': process.env.REACT_APP_API_PATH + 'api/auth/paiement',
        // 'ipnTargetUrl': 'http://bd4195813a6a.ngrok.io/api/paiement/reservation',
        'orderId': 'myOrderId-999999',
        'customer': {
          'email': 'sample@example.com'
        }
      }
      if (props.payload) {
        payload = props.payload
      }

      const result = await allActions.fetchPostAPI(`api/paiement`, payload, dispatch)
      setformToken(result.json.answer.formToken)
    }
    fetchData()
  }, [reload, amount])


  useEffect(async () => {

    if(!formToken) return

    try {
      const res = await KRGlue.loadLibrary(endpoint, publicKey)
      KR.current = res.KR

      KR.current.button.onClick(() => {
        dispatch(allActions.setLoading(true))
      })
      KR.current.onSubmit(onPaid)
      KR.current.callbackHandler.callbacks.onError.push(() => {
        dispatch(allActions.setLoading(false))
      })

      await KR.current.setFormConfig({ formToken: formToken, 'kr-language': 'fr-FR' })
      const { result } = await KR.current.attachForm('#myPaymentForm')
      await KR.current.showForm(result.formId)

    } catch (error) {
      console.log(error)
    }

    let ready = false
    KR.current.callbackHandler.callbacks.onFormReady.push(() => {ready = true})
    KR.current.callbackHandler.callbacks.onLog.push((e) => {
      if (ready && props.onReady) props.onReady(e.timestamp)
    })

    return () => {
      removeForm()
      if (props.onRemove) props.onRemove()

    }
  }, [formToken, KR])


  const removeForm = () => {
    if (KR.current) KR.current.removeForms('#myPaymentForm')
  }

  /**
    * Called when payment is finished
    * @param event
    */
  function onPaid(event) {

    dispatch(allActions.setLoading(false))

    if (event.clientAnswer.orderStatus === 'PAID') {
      if (callback) callback(event.clientAnswer)
      enqueueSnackbar(`Paiement accepté `, { variant: 'success' })
      if (props.onClose) props.onClose()
      // // Remove the payment form
      // event.KR.removeForms();
      removeForm()

    } else {
      if (callback) callback(false)
      props.onClose()
      enqueueSnackbar(`Paiement refusé `, { variant: 'Error' })
    }
    if (props.handleClose) props.handleClose()
  }


  return (
    <div className="form" style={{ width: '100%', boxSizing: 'border-box', minHeight: 189 }}>
      <div className="container">
        <div id="myPaymentForm">
          <div className="kr-smart-form"></div>
        </div>
        <div>{promiseError}</div>
      </div>
    </div>

  )
}
